import AppRouter from './router'
import AppRuntimeController from '@runtime/AppRuntimeController.jsx'
import RuntimeDebugPanel from '@runtime/RuntimeDebugPanel.jsx'

export default function App() {
    return (
        <>
            <AppRuntimeController/>
            <AppRouter/>
            <RuntimeDebugPanel/>
        </>
    )
}
